import { render } from "./AcademySettingsComponent.vue?vue&type=template&id=7a7048df"
import script from "./AcademySettingsComponent.vue?vue&type=script&lang=js"
export * from "./AcademySettingsComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__